// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3MiH3","colMin":"styles_colMin__KuACr","colCheckbox":"styles_colCheckbox__XIXRt"};